<footer
  id="footer"
  class="print:hidden"
  role="contentinfo"
  aria-label="Site footer"
>
  <!-- Copyrights -->
  <div class="mx-auto px-4">
    <div class="py-0 sm:py-8">
      <div class="flex justify-center">
        <div class="text-center text-sm leading-relaxed">
          <p
            class="mb-20 sm:mb-2"
            [innerHTML]="options().siteInfo?.copyright"
          ></p>
        </div>
      </div>
    </div>
  </div>
</footer>
